import React from 'react';
import PageNavControls from 'components/PageNavControls';
import { IProps, IState } from './types';
import commonService from 'utils/commonService';
import { Article } from 'bff/models/new/article';
import newListService from 'bff/services/newListService';
// import moment from 'moment';
import moment from 'moment-timezone';
import { RouterSettings } from 'constants/models/routerSettings';
import storageService from 'utils/storageService';
import { storageKeys } from 'constants/enums/storageKeys.enum';

class NewsRelease extends React.Component<IProps, IState> {
  componentDidMount () {
    // 頁面初始取得傳入的部落格文章
    if (!storageService.getItem(storageKeys.NewsDetail)) {
      this.props.history.goBack();
      return;
    }

    const releaseInfo = JSON.parse(storageService.getItem(storageKeys.NewsDetail)) as Article;

    this.setState({ releaseInfo: releaseInfo });
  }

  componentDidUpdate () {
    // 內容資料有更動，移至畫面上方
    commonService.scrollToTop();
  }

  componentWillUnmount () {
    // 頁面關閉，暫存明細資料
    storageService.removeItem(storageKeys.NewsDetail);
    storageService.setItem(storageKeys.NewsDetail, JSON.stringify(this.state.releaseInfo));
  }

  render () {
    /**
     * @description 點選上下一則的事件
    */
    const handleNextPrevClick = async (sn: number) => {
      if (!sn) return;
      const releaseInfo = await newListService.fetchArticle(sn);
      if (!releaseInfo) return;

      storageService.removeItem(storageKeys.NewsDetail);
      storageService.setItem(storageKeys.NewsDetail, JSON.stringify(releaseInfo));
      this.setState({ releaseInfo: releaseInfo });
    };

    return this.state && this.state.releaseInfo && (
      <div className="news-release">
        <div className="template-container">
          <div className="template-content">
            <div className="news-release__header">
              <div className="news-release__period">
                <span>更新日期：{moment(this.state.releaseInfo.CREATE_TIME).format('YYYY/MM/DD')}</span>
              </div>
              <div className="news-release__title">
                {this.state.releaseInfo.TITLE}
              </div>
            </div>
            <div className="news-release__content">
              <p>{`記者:${this.state.releaseInfo.AUTHOR_NAME}`}</p>
              <p>{commonService.htmlParser(this.state.releaseInfo.CONTENT)}</p>
              <p>新聞來源：
                <a className="element__link" href={this.state.releaseInfo.SRC_URL} target="_blank" rel="noopener noreferrer">{this.state.releaseInfo.SRC_URL}</a>
              </p>
            </div>
          </div>
        </div>
        {/* 頁面導航控制項 */}
        <PageNavControls
          prevBtnLink="/"
          onPrevClick={() => handleNextPrevClick(this.state.releaseInfo?.PREV_SN || 0)}
          nextBtnLink="/"
          onNextClick={() => handleNextPrevClick(this.state.releaseInfo?.NEXT_SN || 0)}
          navBtnLink={RouterSettings.News.List}
          navBtnText="回最新消息頁"
          prevSN={this.state.releaseInfo.PREV_SN}
          nextSN={this.state.releaseInfo.NEXT_SN}
        />
      </div>
    );
  }
};

export default NewsRelease;
